module.exports = __webpack_public_path__ + "static/media/ic-burger-holo.18a37cbc.svg";